import { render } from "./modalsContainer.vue?vue&type=template&id=320e6b8c&scoped=true&ts=true"
import script from "./modalsContainer.vue?vue&type=script&lang=ts"
export * from "./modalsContainer.vue?vue&type=script&lang=ts"

import "./modalsContainer.vue?vue&type=style&index=0&id=320e6b8c&scoped=true&lang=css"
import "./modalsContainer.vue?vue&type=style&index=1&id=320e6b8c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320e6b8c"]])

export default __exports__